import ScansGroupedReport from "./ScansGroupedReport";

export default function ScanByUser() {
  return (
    <ScansGroupedReport
      title="Scan by User"
      subtitle="Scan records grouped by the user who registered the fuel access."
      dimension="user"
      dropdownLabel="User"
      dropdownPlaceholder="All users"
      dropdownApiPath="/members"
    />
  );
}
